// termsAndConditions html returned from prodcat data can begin with closing p tag,
// this needs to be stripped to avoid markup/styling issues
export const sanitiseTerms = (terms: string) =>
  terms?.startsWith("</p>") ? terms.replace("</p><p>", "<p>") || "" : terms;
